import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.some.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
const d = "REI_WEB_SSCID", m = "loggedin", o = "sscid-pi-status", p = "/session-customer-identifier/signals/pi", g = "/session-customer-identifier/signals/pi/thirdparty", r = "https://future.rei.com", i = "https://next.rei.com", c = "https://www.rei.com", E = ["rei", "rei-cloud"], S = ["wwww", "next", "future"], I = ["rei.porbeta.com"], _ = ["training.next-rentals"], R = (t) => I.some((s) => t.includes(s)), f = (t) => _.some((s) => t.includes(s)), P = () => {
  const {
    hostname: t
  } = document.location, s = t.split("."), e = s[s.length - 3], u = s[s.length - 2];
  return R(t) ? r : f(t) ? i : !S.includes(e) && E.includes(u) ? c : window.location.origin;
}, a = () => {
  const t = localStorage.getItem("sscid");
  if (t)
    return t;
  const s = crypto.randomUUID();
  return localStorage.setItem("sscid", s), s;
}, n = () => localStorage.getItem(o) === "201", h = () => document.cookie.split(";").some((t) => t.trim().startsWith(`${m}=1`)), A = () => {
  const t = new URL(document.URL);
  return t.origin === r || t.origin === i || t.origin === c;
}, l = (t) => localStorage.setItem(o, t), C = async (t) => {
  if (!navigator.globalPrivacyControl || n()) return !1;
  const s = {
    ...t
  };
  Object.hasOwn(s, "sscid") || (s.sscid = a());
  try {
    const e = await fetch(p, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(s)
    });
    return l(e.status), e.status === 201;
  } catch (e) {
    return console.error("Error sending PI user value:", e), null;
  }
}, O = async () => {
  if (!navigator.globalPrivacyControl || n()) return !1;
  const t = a();
  try {
    const s = await fetch(P() + g, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        sscid: t,
        appnamespace: d
      })
    });
    return l(s.status), s.status === 201;
  } catch (s) {
    return console.error("Error sending sscid value:", s), null;
  }
}, v = async () => n() || A() && !h() ? !1 : await O();
export {
  P as getBaseURL,
  a as getSSCID,
  C as sendPiUserValue,
  v as sscidListener
};
